export const getUserPoints = `query GetUserPoints($id: ID!) {
    getUserPoints(id: $id) {
      id
      points
    }
  }
  `;
